import type { Session } from "../session";
import type { tags } from "../tags";

// `?a=` free text we group on: fold case and whitespace. Missing or empty is
// "unknown" so the operation stays in vendor breakdowns.
const vendor = (value?: string) => value?.trim().toLowerCase() || "unknown";

export function tags_fromSession(session: Session) {
	return {
		"zeller.session.clientName": session.clientName,
		"zeller.session.clientVersion": session.clientVersion,
		"zeller.session.vendorName": vendor(session.vendorName),
		"zeller.session.vendorApplicationName": vendor(
			session.vendorApplicationName,
		),
		"zeller.session.vendorApplicationVersion":
			session.vendorApplicationVersion?.trim() || "unknown",
		"zeller.session.vendorDeviceType": vendor(session.vendorDeviceType),
	} satisfies tags.Tags;
}
